module.exports = __webpack_public_path__ + "img/flag-blue.445b5b34.svg";